var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCursorBox = function SvgCursorBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M14 6.333V5.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C12.48 2 11.92 2 10.8 2H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 3.52 2 4.08 2 5.2v5.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 14 4.08 14 5.2 14h1.133m5.258-2.193-1.132 2.103c-.185.344-.278.516-.39.56a.33.33 0 0 1-.299-.026c-.103-.063-.165-.249-.287-.619L7.667 8.341c-.108-.325-.161-.487-.123-.595a.33.33 0 0 1 .202-.202c.108-.038.27.015.595.123l5.484 1.816c.37.122.556.184.62.287.055.09.064.2.026.298-.045.113-.217.206-.56.39l-2.104 1.133c-.052.028-.078.042-.1.06a.3.3 0 0 0-.056.055c-.018.023-.032.05-.06.101"
  })));
};
export default SvgCursorBox;